<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">

<div class="padded-container">
  <dx-form [formData]="servedServicePointsResponse">
    <dxi-item [dataField]="'servicePointServicePointName'" [label]="{ text: ('ServicePoint' | translate) }"></dxi-item>
    <dxi-item [dataField]="'servicePointClientCode'" [label]="{ text: ('ClientCode' | translate) }"></dxi-item>
    <dxi-item [dataField]="'servicePointClientName'" [label]="{ text: ('Client' | translate) }"></dxi-item>
    <dxi-item [dataField]="'documentComment'" [label]="{ text: ('Comment' | translate) }"></dxi-item>
  </dx-form>

  <fieldset>
    <legend>{{ 'Packs' | translate }}</legend>
    <dx-form [formData]="servedServicePointsResponse">
      <dxi-item>
        <dx-button class="full-width-button" text="{{ 'Add' | translate }}" type="success" (onClick)="addPackageCounts()"></dx-button>
      </dxi-item>
    </dx-form>
  
    <div *ngIf="servedServicePointsResponse?.packagesList">
      <div *ngFor="let item of servedServicePointsResponse?.packagesList">
        <dx-button class="full-width-button" text="{{ item.packageTypeName }}: {{ item.packageCount }}" type="default" (onClick)="editPackageCounts(item.id ?? 0)"></dx-button>
      </div>
    </div>
  </fieldset>

  <dx-button class="full-width-button" text="{{ 'Accept' | translate }}" type="default" (onClick)="acceptBtnClick()"></dx-button>
  <dx-button class="full-width-button" text="{{ 'Reject' | translate }}" type="default" (onClick)="rejectBtnClick()"></dx-button>
  <dx-button class="full-width-button" text="{{ 'Back' | translate }}" type="default" (onClick)="backBtnClick()"></dx-button>

</div>
</div>

<dx-popup [(visible)]="packageEditFormPopupVisible" [width]="isMobile ? '100%' : '60%'" [height]="isMobile ? '100%' : '80%'" [showTitle]="true" [class.full-screen-popup]="isMobile" title="{{ 'PackCountAddingOrCorrection' | translate }}" [showCloseButton]="true" (onHiding)="cancelUpdatePackageCount()">
  <div class="popup-content">
    <dx-form *ngIf="packageCountModel" [formData]="packageCountModel">
      <dxi-item [dataField]="'dioPackageTypeId'" [label]="{ text: ('PackageType' | translate) }">
        <dx-select-box 
  [dataSource]="dioPackageTypes?.dioPackageTypesList || []" 
  [displayExpr]="displayPackageType" 
  valueExpr="id" 
  [(value)]="packageCountModel.dioPackageTypeId"
  [searchEnabled]="true"
  [searchExpr]="'packageTypeName'"
  placeholder="{{ 'ChoosePackageType' | translate }}"
  [noDataText]="'NoMatchingPackageTypes' | translate"> 
</dx-select-box>
      </dxi-item>
      <dxi-item
      *ngIf="packageCountModel?.packageCount !== null && packageCountModel?.packageCount !== undefined"
      [dataField]="'packageCount'"
      [label]="{ text: ('TotalPackCount' | translate) }">
      <dx-number-box
        [value]="$any(displayPackageCount)"
        [readOnly]="true">
      </dx-number-box>
    </dxi-item>
    
    <dxi-item
      *ngIf="packageCountModel?.manualCount !== null && packageCountModel?.manualCount !== undefined"
      [dataField]="'manualCount'"
      [label]="{ text: ('ManualPackCount' | translate) }">
      <dx-number-box
        [value]="$any(displayManualCount)"
        [showSpinButtons]="true"
        [step]="1"
        (onValueChanged)="onManualCountChanged($event.value)">
      </dx-number-box>
    </dxi-item>
    </dx-form>

    <dx-button class="full-width-button" text="{{ 'Scan' | translate }}" iconCssClass="ion ion-ios-barcode"
          type="default" (click)="toggleScanBarcode()">
        </dx-button>

        <div class="scanner-container">
          <barcode-scanner-livestream #scanner [config]="config" (valueChanges)="onValueChanges($event)"
  [ngClass]="{'full-screen-camera': isCameraFullScreen}">
</barcode-scanner-livestream>
        </div>
    
        <div class="zoom-slider-container" *ngIf="ShowScanBarcode">
          <i class="dx-icon dx-icon-minus"></i>
          <input type="range" id="zoomSlider" min="1" max="10" [(ngModel)]="cameraZoom" (input)="updateCameraZoom()">
          <i class="dx-icon dx-icon-plus"></i>
        </div>

        <dxi-item [dataField]="'scannedNumberCounts'" [label]="{ text: ('ScannedPackCount' | translate) }">
          <dx-number-box [value]="packageCountModel?.scannedNumberCounts ?? 0" [readOnly]="true"></dx-number-box>
        </dxi-item>
        <dxi-item [dataField]="'scannedNumbers'" [label]="{ text: ('ScannedNumbers' | translate) }">
          <div *ngIf="(scanCodes?.length ?? 0) > 0; else noDataTemplate">
            <dx-data-grid [dataSource]="scanCodes" [selection]="{ mode: 'multiple' }" (onSelectionChanged)="onSelectedItemsChanged($event)">
              <dxi-column dataField="code" caption="{{ 'ScannedCode' | translate }}"></dxi-column>
            </dx-data-grid>
          </div>
          <ng-template #noDataTemplate>
            <p class="no-data-text">{{ 'NoPacksAdded' | translate }}</p>
          </ng-template>
        </dxi-item>
        <dxi-item>
          <dx-button class="full-width-button" text="{{ 'DeleteSelected' | translate }}" type="danger" [disabled]="!removeItemBtnEnabled" (onClick)="removeItemBtnClick()"></dx-button>
        </dxi-item>

  </div>
  <div class="popup-footer">
    <dx-button 
  text="{{ 'Save' | translate }}" 
  type="success" 
  (onClick)="acceptUpdatePackageCount()" 
  [disabled]="!packageCountModel?.dioPackageTypeId">
</dx-button>
    <dx-button text="{{ 'Cancel' | translate }}" type="default" (onClick)="cancelUpdatePackageCount()"></dx-button>
    <dx-button *ngIf="packageCountModel?.id !== 0" text="{{ 'Delete' | translate }}" type="danger" (onClick)="removeUpdatePackageCount()"></dx-button>
  </div>
</dx-popup>

<dx-popup [(visible)]="acceptPopupVisible" [width]="isMobile ? '100%' : '60%'" [height]="isMobile ? '100%' : '80%'" [showTitle]="true" [class.full-screen-popup]="isMobile" title="{{ 'Acceptance' | translate }}" [showCloseButton]="true" (onHiding)="onPopupHiding()"(onHiding)="cancelUpdatePackageCount()">
  <div class="popup-content">
    <dx-form [formData]="servedServicePointsResponse">
      <dxi-item [dataField]="'receiverName'" [label]="{ text: ('Receiver' | translate) }"></dxi-item>
    </dx-form>
    <div *ngIf="acceptPopupVisible">
      <canvas ejs-signature #signature id="signature" style="height: 90%; width: 100%;" (change)="onSignatureChange()"></canvas>
    </div>
    <div class="popup-footer">
      <dx-button text="{{ 'Accept' | translate }}" type="success" (onClick)="acceptFormOkBtnClick()"></dx-button>
      <dx-button text="{{ 'Cancel' | translate }}" type="default" (onClick)="acceptFormCancelBtnClick()"></dx-button>
    </div>
  </div>
</dx-popup>

<dx-popup [(visible)]="rejectPopupVisible" [width]="isMobile ? '100%' : '60%'" [height]="isMobile ? '100%' : '80%'" [showTitle]="true" [class.full-screen-popup]="isMobile" title="{{ 'Rejection' | translate }}" [showCloseButton]="true" (onHiding)="cancelUpdatePackageCount()">
  <div class="popup-content">
    <dx-form [formData]="servedServicePointsResponse">
      <dxi-item [dataField]="'rejectReason'" [label]="{ text: ('RejectionReason' | translate) }"></dxi-item>
    </dx-form>
    <div class="popup-footer">
      <dx-button text="{{ 'Reject' | translate }}" type="danger" (onClick)="rejectFormOkBtnClick()"></dx-button>
      <dx-button text="{{ 'Cancel' | translate }}" type="default" (onClick)="rejectFormCancelBtnClick()"></dx-button>
    </div>
  </div>
</dx-popup>

<img *ngIf="signatureHtmlSource" style="width:100%;" [src]="signatureHtmlSource" />